import React from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  trend?: string;
  color?: string;
}

export const StatCard: React.FC<StatCardProps> = ({ label, value, trend, color = "text-white" }) => {
  return (
    <div className="bg-surface border border-white/5 rounded-2xl p-4 flex flex-col justify-between min-w-[140px]">
      <span className="text-sm text-slate-400 font-medium">{label}</span>
      <div className="mt-2 flex items-end justify-between">
        <span className={`text-3xl font-bold tracking-tight ${color}`}>{value}</span>
        {trend && <span className="text-xs text-primary mb-1">{trend}</span>}
      </div>
    </div>
  );
};